export default function isFunction(a) {
  return typeof a == "function";
}
